export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10228.988b37a8.jpg";